var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6102 11.0703L17.2891 12.7308L12.861 9.40975L11.7539 15.4984L15.6285 18.8195L16.182 23.8011M20.6102 9.40975V23.8011M11.7539 18.8195L9.53986 23.8011M10.0934 9.40975C8.43283 10.5168 7.32581 13.2844 7.32581 13.2844L9.53986 14.3914M13.968 7.1957C14.5552 7.1957 15.1183 6.96243 15.5336 6.54721C15.9488 6.132 16.182 5.56884 16.182 4.98164C16.182 4.39443 15.9488 3.83128 15.5336 3.41606C15.1183 3.00084 14.5552 2.76758 13.968 2.76758C13.3808 2.76758 12.8176 3.00084 12.4024 3.41606C11.9872 3.83128 11.7539 4.39443 11.7539 4.98164C11.7539 5.56884 11.9872 6.132 12.4024 6.54721C12.8176 6.96243 13.3808 7.1957 13.968 7.1957Z",
    stroke: "#969696",
    strokeWidth: 2.21406,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.d26517940ea8bf6f0cfb84ecc21c1459.svg";
export { ForwardRef as ReactComponent };